import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Document from "src/components/Document/Document";
// ----------------------------------------------------------------------

export default function SubjectmatterexpertDocument() {
  return (
    <>
      <Helmet>
        <title> Subject Matter Expert Document </title>
      </Helmet>

      <Container maxWidth="xl">
        <Document Role="Subject-Matter-Expert" />
      </Container>
    </>
  );
}
